import React from 'react';
import { Box, Stack } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { styles } from './styles';
import { renderAnswer } from '../Application/OverviewTab/Responses';
import dompurify from 'dompurify';
import { useQueryClient } from '@tanstack/react-query';

export default function Responses() {
  const queryClient = useQueryClient();
  const externalViewData = queryClient.getQueryData<any>(['externalViewData']);
  const ConfidentialAnswerView = () => (
    <Stack sx={{ flexDirection: 'row', gap: 1, color: '#939393', fontStyle: 'italic' }}>
      <LockIcon sx={{ fontSize: 16 }} />
      Confidential: Your current permissions do not allow you to view this information.
    </Stack>
  );
  return (
    <Stack sx={styles.sectionContainer}>
      <Stack
        sx={{
          fontSize: { xs: '15px', sm: '16px' },
          fontWeight: 600
        }}
      >
        Responses
      </Stack>
      <Stack
        sx={{
          color: '#666666',
          fontWeight: 'bold',
          fontSize: { xs: '14px', sm: '16px' }
        }}
      >
        Questions/Answers
      </Stack>
      {externalViewData?.application.job.questions.map((q) => {
        const answerFound = externalViewData.application.responses.find((r) => r.field_id === q.id);
        return (
          <Stack
            sx={{
              rowGap: 1,
              padding: { xs: 1, sm: 0 },
              borderBottom: { xs: '1px solid #f0f0f0', sm: 'none' },
              marginBottom: { xs: 1, sm: 0 }
            }}
            key={q.id}
          >
            <Box
              key={q.id}
              sx={{
                color: '#084D6D',
                fontWeight: 'bold',
                fontSize: { xs: '14px', sm: '16px' },
                wordBreak: 'break-word'
              }}
              dangerouslySetInnerHTML={{
                __html: dompurify.sanitize(q.title)
              }}
            />
            {q.confidential ? (
              <ConfidentialAnswerView />
            ) : (
              <Box sx={{ fontSize: { xs: '13px', sm: '14px' } }}>
                {renderAnswer(q, answerFound)}
              </Box>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
}
